import ColorableCodeList from '@/modules/common/domain/colorableCodeList'
import { MoneyMovementType } from '@/modules/money/movement/type/moneyMovementType'

class MoneyMovementCategory extends ColorableCodeList {
  type?: MoneyMovementType
}

export default MoneyMovementCategory
